<template>
  <div class="page product-con">
    <div class="cover">
      <div class="main-content">
        <img v-if="scheme.flag=='Z5'" src="@assets/images/eval/Z5-end.jpg" class="image" />
        <img v-else-if="scheme.flag=='Z3-Manage'||scheme.flag=='Z3-Manage'||scheme.flag=='Z3-Manage'" src="@assets/images/eval/Z3-end.jpg" class="image" />
        <img v-else-if="scheme.flag=='fenc-simple'||scheme.flag=='fenc-m'" src="@assets/images/eval/fenc-end.jpg" class="image" />

        <vant-button class="order-btn" v-if="!order||order.status==0" round block color="#315ace" @click="tapBuy">打赏 ￥{{ project.price }}</vant-button>
        <vant-button class="order-btn" v-else round block color="#315ace" @click="toPdf">查看报告</vant-button>
        <div class="intro"> {{ project.intro }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Button as VantButton } from "vant";
import { createOrder, fetchOrderByProjectId, getPaySignature, updateProjectPaid, getProjectInfo, getSchemeInfo, getReport } from "@api/eval";
import { pay } from "@libs/wechat";
import { mapGetters } from "vuex";


export default {
  components: {
    VantButton
  },
  props: {},
  data: function() {
    return {
      toBuy: false,
      projectId: this.$route.params.projectId,
      order: {},
      scheme: {},
      project: {}
    };
  },
  computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.init();
  },
  methods: {
    init() {
      this.findOrder();
      this.getProject();
      this.getScheme();
    },

    findOrder() {
      fetchOrderByProjectId(this.projectId).then(res => {
        this.order = res.result;
      });
    },
    getScheme() {
      getSchemeInfo(this.projectId).then(res => {
        this.scheme = res.result || {};
      });
    },
    getProject() {
      getProjectInfo(this.projectId).then(resp => {
        this.project = resp.result || {};
      });
    },
    toView() {
      updateProjectPaid(this.projectId).then(res => {
        console.info("支付成功！");
      });
    },
    tapBuy() {
      if (this.order && this.order.id && this.order.status == 0) {
        getPaySignature(this.projectId, this.order).then(res => {
          pay(res.result).then(res => {
            console.info("再次支付成功！");
            this.$nextTick(() => {
              this.toView();
              this.findOrder();
            });
          }).catch(er => {
            console.info("取消支付", er);
          });
        });
      } else if (this.order && this.order.id && this.order.status >= 1) {
        this.toView();
      } else if (!this.order) {
        this.createOrder();
      }
    },
    createOrder() {
      Toast.loading({ message: "生成订单中", forbidClick: true });
      createOrder(this.projectId).then(res => {
        const data = res.result;
        if (res.code === 200) {
          pay(data).then(resp => {
            console.info("支付成功！");
            this.$nextTick(() => {
              this.toView();
              this.findOrder();
            });
          }).catch(er => {
            console.info("取消支付", er);
            this.init();       //获取刚刚创建的订单
          });
        } else {
          Toast.fail(res.message || "创建订单失败");
        }
      }).catch(err => {
        Toast.fail(err.msg || "拉起支付失败！");
      });
    },
    toPdf() {
      let report = {};
      getReport(this.projectId).then(resp => {
        report = resp.result || {};
        if (report === {}) {
          Toast.fail("报告未生成，请联系管理员");
        } else {
          location.href = `/api/evaluate/report/pdf/${report.id}/${this.scheme.id}`;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  background-color: #f5f5f5;
  min-height: 100vh;

  .main-content {
    display: block;
    box-sizing: border-box;
    position: relative;

    ::v-deep img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .footer {
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    padding: 10px 30px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }

  .order-btn {
    position: absolute;
    left: 0;
    right: 0;
    top: 400px;
    width: 200px;
    margin: 0 auto;
  }

  .intro {
    position: absolute;
    left: 0;
    right: 0;
    top: 470px;
    width: 220px;
    margin: 0 auto;
    color: #4b4b4b;
    font-size: 12px;
    text-align: center;
  }
}
</style>
